var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4012 16.1458L18.331 13.0756C17.2345 11.9791 15.3705 12.4178 14.9319 13.8432C14.603 14.83 13.5065 15.3783 12.5196 15.1589C10.3267 14.6107 7.36615 11.7598 6.8179 9.45721C6.48896 8.47033 7.14685 7.37384 8.13369 7.04493C9.55912 6.60634 9.99772 4.74231 8.90123 3.64582L5.83107 0.575656C4.95387 -0.191885 3.63809 -0.191885 2.87055 0.575656L0.787221 2.65898C-1.29611 4.85196 1.00652 10.6633 6.16001 15.8168C11.3135 20.9703 17.1249 23.3826 19.3179 21.1896L21.4012 19.1063C22.1688 18.2291 22.1688 16.9133 21.4012 16.1458Z",
    fill: "#4C4F5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPhone);
export default __webpack_public_path__ + "static/media/user-phone.aadc2a75decd8ec7d3691a39d752e2ff.svg";
export { ForwardRef as ReactComponent };